"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { Wordmark } from "./Logo";

const NAV = [
  { label: "About", href: "/about" },
  { label: "How it works", href: "/#why" },
  { label: "Safety", href: "/safety" },
  { label: "Support", href: "/support" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const firstMobileLink = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (open) firstMobileLink.current?.focus();
  }, [open]);

  return (
    <header className="site-header" onKeyDown={(event) => { if (event.key === "Escape") setOpen(false); }}>
      <div className="site-container flex h-16 items-center justify-between">
        <Wordmark />

        <nav aria-label="Primary navigation" className="hidden items-center gap-7 md:flex">
          {NAV.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className="site-nav-link"
            >
              {item.label}
            </Link>
          ))}
          <Link
            href="/download"
            className="site-cta"
          >
            Download
          </Link>
        </nav>

        <button
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="mobile-menu-button md:hidden"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open ? (
              <>
                <path d="M6 6l12 12" />
                <path d="M18 6L6 18" />
              </>
            ) : (
              <>
                <path d="M4 7h16" />
                <path d="M4 12h16" />
                <path d="M4 17h16" />
              </>
            )}
          </svg>
        </button>
      </div>

      {open && (
        <nav aria-label="Mobile navigation" className="mobile-menu md:hidden">
          <div className="site-container flex flex-col gap-1 py-4">
            {NAV.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                ref={item === NAV[0] ? firstMobileLink : undefined}
                onClick={() => setOpen(false)}
                className="mobile-menu-link"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/download"
              onClick={() => setOpen(false)}
              className="site-cta mt-2 justify-center"
            >
              Download
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
